import { useLazyQuery } from '@apollo/client';
import { useCallback } from 'react';
import { SEARCH_TOOL_ROOM } from '../gql/queries/tool-room';

export const useSearchToolRoom = () => {
  const [searchToolRoomQuery, { data, loading, error }] = useLazyQuery<any>(SEARCH_TOOL_ROOM);
  const searchToolRoom = useCallback(
    (searchInput, onComplete?: (data) => void) => {
      searchToolRoomQuery({
        variables: {
          searchInput: searchInput,
        },
        onCompleted: (data) => {
          if (onComplete) {
            onComplete(data);
          }
        },
        fetchPolicy: 'network-only',
      });
    },
    [searchToolRoomQuery]
  );

  return { searchToolRoom, data, loading, error };
};
